import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useGlobalContext } from "../GlobalContext";

const ListRole = () => {
  const { api, isReady } = useGlobalContext();
  const [roles, setRoles] = useState([]);
  const [modalAddOpen, setModalAddOpen] = useState(false);
  const [modalEditOpen, setModalEditOpen] = useState(false);
  const [searchText, setSearchText] = useState("");

  const [form, setForm] = useState({
    kode_role: "",
    keterangan: "",
    status: true,
  });

  const getRoles = async () => {
    try {
      const response = await api.get("/api/setup/role");
      setRoles(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error("Gagal mengambil data role:", error);
      if (error.response && error.response.status === 401) {
        alert("Akses ditolak. Silakan login kembali.");
      }
    }
  };

  useEffect(() => {
    if (isReady) {
      getRoles();
    }
  }, [isReady]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const val = type === "checkbox" ? checked : value;
    setForm({ ...form, [name]: val });
  };

  const handleSubmitAdd = async () => {
    try {
      await api.post("/api/setup/role", {
        ...form,
        status: form.status ? '1' : '0',
      });
      setModalAddOpen(false);
      getRoles();
    } catch (error) {
      console.error("Gagal menambah role:", error);
      alert("Gagal menambah role");
    }
  };

  const handleEdit = (row) => {
    setForm({
      kode_role: row.kode_role || '',
      keterangan: row.keterangan || '',
      status: row.status === '1' || row.status === 1 || row.status === 'true', 
    });
    setModalEditOpen(true);
  };

  const handleUpdate = async () => {
    try {
      const payload = {
        kode_role: form.kode_role,
        keterangan: form.keterangan,
        status: form.status ? '1' : '0',
      };
      await api.patch(`/api/setup/role/`, payload);
      setModalEditOpen(false);
      getRoles();
    } catch (error) {
      console.error("Gagal mengedit role:", error);
      alert("Gagal mengedit role");
    }
  };
  const handleDelete = async (kode) => {    
    if (window.confirm("Yakin hapus role ini?")) {
      try {        
        await api.delete(`/api/setup/role/${kode}`);
        getRoles();
      } catch (error) {
        console.error("Gagal menghapus role:", error);
        alert("Gagal menghapus role: " + error.message);
      }
    }
  };

  const columns = [
    {
      name: "No",
      selector: (row, index) => index + 1,
      width: "5%",
      center: true,
    },
    {
      name: "Kode Role",
      selector: (row) => row.kode_role,
      width: "10%",
      sortable: true,
      center: true,
    },
    {
      name: "Keterangan",
      selector: (row) => row.keterangan,
      sortable: true,
    },
    {
      name: 'Status',
      selector: row => row.status === '1' || row.status === 1 || row.status === 'true' ? 'Aktif' : 'Tidak Aktif',
      sortable: true,
      width: '120px',
      center: true,
    },
    {
      name: "Aksi",
      width: "10%",
      cell: (row) => (
        <div className="d-flex gap-2 justify-content-center">
          <button className="btn btn-info btn-sm" onClick={() => handleEdit(row)}>
            <i className="fa fa-edit" />
          </button>
          <button className="btn btn-danger btn-sm" onClick={() => handleDelete(row.kode_role)}>
            <i className="fa fa-trash" />
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      center: true,
    },
  ];

  const filteredData = roles.filter(
    (item) =>
      item.kode_role.toLowerCase().includes(searchText.toLowerCase()) ||
      item.keterangan.toLowerCase().includes(searchText.toLowerCase())
  );

  const customStyles = {
    headCells: {
      style: {
        fontSize: "18px",
        fontWeight: "bold",
        paddingTop: "12px",
        paddingBottom: "12px",
        borderBottom: "1px solid #dee2e6",
      },
    },
    cells: {
      style: {
        fontSize: "17px",
        paddingTop: "10px",
        paddingBottom: "10px",
        borderBottom: "1px solid #dee2e6",
      },
    },
    rows: {
      style: {
        borderBottom: "1px solid #dee2e6",
      },
    },
  };

  return (
    <div className="card shadow-sm">
      <div className="card-header">
          <div className="d-flex justify-content-end align-items-center w-100">
            <h4 className="mb-0" style={{ fontSize: "22px" }}>DAFTAR ROLE</h4>
            <button
            className="btn btn-primary btn-sm"
            style={{ fontSize: "14px", padding: "6px 14px" }}
            onClick={() => {
              setForm({ kode_role: "", keterangan: "", status: true });
              setModalAddOpen(true);
            }}
            >
            Tambah Data
          </button>
          </div>
        </div>

      <div className="card-body">
        <div className="mb-2 d-flex justify-content-end">
          <input
            type="text"
            className="form-control form-control-sm"
            style={{ maxWidth: "200px" }}
            placeholder="Cari kode/keterangan..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          striped
          dense
          highlightOnHover
          responsive
          customStyles={{
            headCells: {
              style: {
                fontWeight: "bold",
                fontSize: "16px",
                backgroundColor: "#f0f0f0",
                padding: "10px 12px",
                borderRight: "2px solid #ddd",
              },
            },
            cells: {
              style: {
                borderRight: "1px solid #ddd",
                padding: "12px 10px",
              },
            },
            rows: {
              style: {
                borderBottom: "1px solid #eee",
              },
            },
          }}
          className="table table-bordered"
        />
      </div>

      {/* Modal Tambah */}
      {modalAddOpen && (
        <div className="modal show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-md" role="document">
            <div className="modal-content shadow">
              <div className="modal-header">
                <h5 className="modal-title">TAMBAH ROLE</h5>
                <button type="button" className="btn-close" onClick={() => setModalAddOpen(false)}></button>
              </div>
              <div className="modal-body">
                <div className="form-group mb-2">
                  <label>KODE ROLE</label>
                  <input
                    type="text"
                    name="kode_role"
                    className="form-control"
                    value={form.kode_role}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group mb-2">
                  <label>KETERANGAN</label>
                  <input
                    type="text"
                    name="keterangan"
                    className="form-control"
                    value={form.keterangan}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group mb-2 form-check">
                  <input
                    type="checkbox"
                    name="status"
                    className="form-check-input"
                    checked={form.status}
                    onChange={handleInputChange}
                  />
                  <label className="form-check-label">Aktif</label>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary btn-sm" onClick={() => setModalAddOpen(false)}>Batal</button>
                <button className="btn btn-success btn-sm" onClick={handleSubmitAdd}>Simpan</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Edit */}
      {modalEditOpen && (
        <div className="modal show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-md" role="document">
            <div className="modal-content shadow">
              <div className="modal-header">
                <h5 className="modal-title">EDIT ROLE</h5>
                <button type="button" className="btn-close" onClick={() => setModalEditOpen(false)}></button>
              </div>
              <div className="modal-body">
                <div className="form-group mb-2">
                  <label>KODE ROLE</label>
                  <input disabled className="form-control" name="kode_role" value={form.kode_role} />
                </div>
                <div className="form-group mb-2">
                  <label>KETERANGAN</label>
                  <input
                    className="form-control"
                    name="keterangan"
                    value={form.keterangan}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group mb-2 form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    name="status"
                    checked={form.status}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        status: e.target.checked,
                      })
                    }
                  />
                  <label className="form-check-label">Aktif</label>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary btn-sm" onClick={() => setModalEditOpen(false)}>Batal</button>
                <button className="btn btn-success btn-sm" onClick={handleUpdate}>Simpan</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ListRole;